export default __webpack_public_path__ + "static/media/wasp-xcomb.af2f7bc0.png";